import {
  CustomerGroupPerEmailDispatchTypes,
  CUSTOMER_GROUP_PER_EMAIL_LOADING,
  CUSTOMER_GROUP_PER_EMAIL_FAILURE,
  CUSTOMER_GROUP_PER_EMAIL_SUCCESS,
} from "../actions/customerGroupPerEmailActionTypes";

interface CustomerGroupPerEmailState {
  loading: boolean;
  customerGroupPerEmail?: string[];
}

const defaultState: CustomerGroupPerEmailState = {
  loading: false,
};

const customerGroupPerEmailReducer = (
  state: CustomerGroupPerEmailState = defaultState,
  action: CustomerGroupPerEmailDispatchTypes
): CustomerGroupPerEmailState => {
  switch (action.type) {
    case CUSTOMER_GROUP_PER_EMAIL_LOADING:
      return { ...state, loading: true };
    case CUSTOMER_GROUP_PER_EMAIL_FAILURE:
      return { ...state, loading: false };
    case CUSTOMER_GROUP_PER_EMAIL_SUCCESS:
      return { loading: false, customerGroupPerEmail: action.payload };
    default:
      return state;
  }
};

export default customerGroupPerEmailReducer;
